<template>
    <el-drawer :modal="false" 
        title="Filter"
        :visible.sync="drawerFilterProformaInvoice"
        class="drawer-filter-proforma-invoice"
        size="20%"
    >
        <b-container>
            <b-row class="text-end">
                <b-col cols="12">
                    <div class="d-flex justify-content-end">
                        <b-button variant="primary" @click="resetFilter">Reset</b-button>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <b-form-group label="Created Date">
                        <div>
                            <div class="mb-2">
                                <el-date-picker
                                    v-model="filter.date_from"
                                    type="date"
                                    placeholder="Date From"
                                    value-format="yyyy-MM-dd"
                                    @change="filterByDate()"
                                />
                            </div>
                            <div class="mb-2 w-100 text-center">
                                To
                            </div>
                            <div class="">
                                <el-date-picker
                                    v-model="filter.date_to"
                                    type="date"
                                    placeholder="Date Until"
                                    value-format="yyyy-MM-dd"
                                    @change="filterByDate()"
                                />
                            </div>
                        </div>
                    </b-form-group>
                </b-col>
                <!-- <b-col cols="12" v-if="filter.date_type">
                    <base-input :label="filter.date_type == 1 ? 'Invoice Date' : 'Created Date' ">
                        <div class="">
                            <div class="mb-2">
                                <el-date-picker
                                    v-model="filter.value1"
                                    type="date"
                                    placeholder="Date From"
                                    value-format="yyyy-MM-dd"
                                    @change="filterByDate()"
                                />
                            </div>
                            <div class="mb-2 w-100 text-center">
                                To
                            </div>
                            <div class="">
                                <el-date-picker
                                    v-model="filter.value2"
                                    type="date"
                                    placeholder="Date Until"
                                    value-format="yyyy-MM-dd"
                                    @change="filterByDate()"
                                />
                            </div>
                        </div>
                    </base-input>
                </b-col> -->
                <b-col cols="12">
                    <b-form-group label="Total Amount(RM)">
                        <div class="d-flex justify-content-between align-items-center">
                            <b-form-group label="Min" class="mr-2">
                                <CurrencyInput
                                    v-model="filter.min_amt"
                                    v-on:input="filterByAmount"
                                    :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                />
                            </b-form-group>
                            <b-form-group label="Max">
                                <CurrencyInput
                                    v-model="filter.max_amt"
                                    v-on:input="filterByAmount"
                                    :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                />
                            </b-form-group>
                        </div>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-container>
    </el-drawer>
</template>
<script>
    import { Button, Drawer, Select, Option, DatePicker } from 'element-ui'
    import {
        notifyFunctionMixin,
        axios,
        services,
        getHeader,
        debounce
    } from '@/assets/js/httpImports.js'
    import CurrencyInput from '@/components/CurrencyInput'

    export default {
        name: 'drawer-filter-proforma-invoice',
        components: {
            CurrencyInput,
            [Button.name]: Button,
            [Drawer.name]: Drawer,
            [Select.name]: Select,
            [Option.name]: Option,
            [DatePicker.name]: DatePicker,
        },
        mounted(){
            this.debouncedHandler = debounce(() => {
                this.searchByFilter();
            }, 500);
        },
        data() {
            return {
                drawerFilterProformaInvoice: false,
                filter: {
                    created_date: "",
                    date_from: "",
                    date_to: "",
                    date_range: [],
                    min_amt: 0.00,
                    max_amt: 0.00,
                },
                debouncedHandler: '',
                channelList: [],
                platformList: [],
                dateTypes: [
                    {
                        type_id:1,
                        type:'Invoice Date',
                    },
                    {
                        type_id:2,
                        type:'Created Date',
                    },
                ],
                open:1,
            };
        },
        methods: {
            viewFilterProformaInvoice() {
                this.drawerFilterProformaInvoice = !this.drawerFilterProformaInvoice;
            },
            searchByFilter() {
                this.$emit('filter-invoice', this.filter.date_range, this.filter.total_amt)
            },
            filterByDate() {
                if(this.filter.date_from && this.filter.date_to) {
                    this.filter.date_range = `${this.filter.date_from},${this.filter.date_to}`
                    this.searchByFilter()
                }else if(!this.filter.date_from && !this.filter.date_to){
                    this.filter.date_range = ''
                    this.searchByFilter()
                }
            },
            filterByAmount() {
                if(this.open > 3) {
                    this.filter.total_amt = `${this.filter.min_amt},${this.filter.max_amt}`
                    this.searchByFilter()
                }
                this.open++
                return ;
            },
            resetFilter() {
                Object.keys(this.filter).forEach( key => {
                    this.filter[key] = ''
                });
                this.searchByFilter()
            },
        }
    }
</script>